var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 55,
    viewBox: "0 0 46 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_415_36756",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6075 0H0V54.4585H45.6075V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_415_36756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7991 43.4309L17.73 44.6329L18.7371 36.3059L36.8851 14.6579C37.6956 13.7559 38.7677 13.2659 39.8754 13.2889C40.9831 13.3119 42.0399 13.8479 42.8234 14.7829C43.6067 15.7189 44.0555 16.9809 44.0749 18.3039C44.0945 19.6259 43.6834 20.9059 42.9281 21.8739L24.7991 43.4309Z",
    stroke: "#AE8FD6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4516 1.70215H23.7538C23.7538 1.70215 25.179 1.70211 25.179 3.40411V9.07715C25.179 9.07715 25.179 10.7791 23.7538 10.7791H10.4516C10.4516 10.7791 9.02637 10.7791 9.02637 9.07715V3.40411C9.02637 3.40411 9.02636 1.70215 10.4516 1.70215Z",
    stroke: "#AE8FD6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1792 6.24023H29.93C30.6859 6.24023 31.4111 6.59924 31.9456 7.23724C32.4802 7.87524 32.7804 8.74123 32.7804 9.64423",
    stroke: "#AE8FD6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7804 42.5463V49.3533C32.7804 50.2563 32.4802 51.1223 31.9456 51.7603C31.4111 52.3983 30.6859 52.7573 29.93 52.7573H4.27579C3.51979 52.7573 2.79469 52.3983 2.26019 51.7603C1.72559 51.1223 1.42529 50.2563 1.42529 49.3533V9.64423C1.42529 8.74123 1.72559 7.87524 2.26019 7.23724C2.79469 6.59924 3.51979 6.24023 4.27579 6.24023H9.02649",
    stroke: "#AE8FD6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97656 19.8545H23.2787",
    stroke: "#AE8FD6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.97656 30.0654H14.7273",
    stroke: "#AE8FD6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.64c3786a713bd8e4e28cd757ffd614f5.svg";
export { ForwardRef as ReactComponent };